'use client';
import React, { useState } from 'react';

const ComingSoon = () => {
    const [email, setEmail] = useState('');
    const [status, setStatus] = useState('');
    const [isLoading, setIsLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        setStatus('');

        try {
            const response = await fetch('/api/newsletter', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ email }),
            });

            if (response.ok) {
                setStatus("Thank you! We'll notify you when we’re back.");
                setEmail('');
            } else {
                setStatus('Something went wrong. Please try again.');
            }
        } catch (error) {
            setStatus('Something went wrong. Please try again.');
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            height: '100vh',
            width: '100%',
            backgroundColor: '#f5f5f5',
            fontFamily: 'Futura, var(--font-geist-sans)'
        }}>
            <h1 style={{
                fontSize: '3rem',
                marginBottom: '1rem',
                fontWeight: 'bold'
            }}>
                Under Revamp
            </h1>
            <p style={{
                fontSize: '1.2rem',
                maxWidth: '650px',
                width: '100%',
                textAlign: 'center',
                marginBottom: '2rem',
                padding: ' 10px 40px'
            }}>
                We&apos;re redesigning things behind the scenes to give you a better experience.
            </p>

            <div style={{
                padding: '2rem',
                borderRadius: '12px',
                marginBottom: '3rem',
                width: '100%',
                maxWidth: '450px'
            }}>
                <h3 style={{
                    fontSize: '1.5rem',
                    marginBottom: '1rem',
                    textAlign: 'center',
                    color: '#333'
                }}>
                    Send us your email to get in touch with you soon!
                </h3>
                <form onSubmit={handleSubmit} style={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '1rem'
                }}>
                    <input
                        type="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        placeholder="Enter your email"
                        required
                        style={{
                            padding: '12px 16px',
                            border: '2px solid #e1e5e9',
                            borderRadius: '8px',
                            fontSize: '1rem',
                            outline: 'none',
                            transition: 'border-color 0.3s ease',
                            fontFamily: 'inherit'
                        }}
                        onFocus={(e) => e.target.style.borderColor = '#007bff'}
                        onBlur={(e) => e.target.style.borderColor = '#e1e5e9'}
                    />
                    <button
                        type="submit"
                        disabled={isLoading}
                        style={{
                            padding: '12px 24px',
                            backgroundColor: isLoading ? '#ccc' : '#000000ff',
                            color: 'white',
                            border: 'none',
                            borderRadius: '8px',
                            fontSize: '1rem',
                            cursor: isLoading ? 'not-allowed' : 'pointer',
                            transition: 'background-color 0.3s ease',
                            fontFamily: 'inherit'
                        }}
                        onMouseOver={(e) => {
                            if (!isLoading) {
                                e.target.style.backgroundColor = '#ffffffff';
                                e.target.style.color = '#000000ff';
                            }
                        }}
                        onMouseOut={(e) => {
                            if (!isLoading) {
                                e.target.style.backgroundColor = '#000000ff';
                                e.target.style.color = '#ffffffff';
                            }
                        }}
                    >
                        {isLoading ? 'Sending...' : 'Notify Me'}
                    </button>
                </form>
                {status && (
                    <p style={{
                        marginTop: '1rem',
                        textAlign: 'center',
                        color: status.includes('Thank you') ? '#28a745' : '#dc3545',
                        fontSize: '0.9rem'
                    }}>
                        {status}
                    </p>
                )}
            </div>

            <div style={{
                fontSize: '1rem',
                opacity: 0.7
            }}>
                © {new Date().getFullYear()} Sagio
            </div>
        </div>
    );
};

export default ComingSoon;
